// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderCrypto_container__2125Q"};